/* ============================================================
   DillySocks — Farbvarianten-Switcher (PDP)
   Laedt die Produktgruppe (custom.produktgruppe) per Storefront-Filter nach
   (Template collection.ds-group, meistverkaufte zuerst) und baut daraus die
   Kachel-Zeile. Jede Kachel zeigt ein Bild (Metafeld custom.kachelbild,
   sonst Hauptbild) — keine Farb-Analyse. Mehrfarbige Bundles (Metafeld
   custom.pack_farben, >= 2 Farben) zeigen stattdessen einen geteilten
   Farbkreis plus Legende "Enthält X Paar". Liefert die Gruppe nichts
   Brauchbares, wird der Switcher entfernt. Aktive Kachel = aktuelles
   Produkt; Klick = Link.
   ============================================================ */
(function () {
  'use strict';

  // Schutz gegen "Filter nicht freigeschaltet" (dann liefert Shopify den
  // ganzen Katalog) — eine echte Gruppe ist nie so gross.
  var MAX_GROUP = 60;

  // Bekannte Linien-Präfixe, um aus dem Produkttitel den reinen Farbnamen zu
  // gewinnen ("Ribbed Sunny Yellow" -> "Sunny Yellow").
  // Laengere Praefixe zuerst ("Active Merino " vor "Active ").
  var PREFIXES = ['Ribbed ', 'Smooth ', 'Short ', 'Hidden ', 'D-Compose ', 'One Color ', 'Sneaker ', 'Active Merino ', 'Active '];

  function colorName(title) {
    var t = title || '';
    for (var i = 0; i < PREFIXES.length; i++) {
      if (t.toLowerCase().indexOf(PREFIXES[i].toLowerCase()) === 0) { t = t.slice(PREFIXES[i].length); break; }
    }
    // Zusatz in Klammern am Ende entfernen, in jeder Sprache: "(3er Pack)",
    // "(pack de 3)", "(paquet de 4)", "(3-pack)", "(pack of 3)", "(2er Box)" ...
    t = t.replace(/\s*\([^()]*\)\s*$/, '');
    return t.trim() || (title || '');
  }

  // Anzahl Paar: Metafeld number_of_socks, sonst die Zahl in der Klammer am
  // Titelende ("(4er Pack)", "(pack de 4)", "(4-pack)").
  function packCount(it) {
    var n = parseInt(it.n, 10);
    if (n > 0) return n;
    var m = /\([^()]*?(\d+)[^()]*\)\s*$/.exec(it.t || '');
    return m ? parseInt(m[1], 10) : 1;
  }

  function fill(tpl, n) { return (tpl || '').replace('__N__', n); }

  // Helligkeit eines Hex (0..255) fuer "hell -> dunkel"-Sortierung.
  function hexLum(hex) {
    var r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
    return 0.299 * r + 0.587 * g + 0.114 * b;
  }

  // Pack-Farben (Metafeld custom.pack_farben), hell -> dunkel; nur bei
  // Bundles mit unterschiedlichen Farben gepflegt (>= 2 Farben).
  function packColors(it) {
    var c = (it.c || []).filter(function (x) { return /^#[0-9a-f]{6}$/i.test(x); });
    return c.length > 1 ? c.slice().sort(function (a, b) { return hexLum(b) - hexLum(a); }) : null;
  }

  /* Aufgeteilter Kreis: gleich grosse Tortensegmente. */
  function conicGradient(colors) {
    var seg = 360 / colors.length;
    var stops = colors.map(function (col, i) {
      return col + ' ' + (i * seg).toFixed(2) + 'deg ' + ((i + 1) * seg).toFixed(2) + 'deg';
    });
    return 'conic-gradient(from -90deg, ' + stops.join(', ') + ')';
  }

  // Gueltige Gruppe? (2..MAX_GROUP Produkte, aktuelles Produkt enthalten)
  function validGroup(products, currentHandle) {
    if (!products || products.length < 2 || products.length > MAX_GROUP) return null;
    if (!products.some(function (it) { return it.h === currentHandle; })) return null;
    return products.map(function (it) {
      var c = {}; for (var k in it) c[k] = it[k];
      c.cur = it.h === currentHandle;
      return c;
    });
  }

  // Browser-Cache pro Gruppe (sessionStorage): beim Durchklicken der Farben
  // sind die Kacheln sofort da; frische Daten kommen im Hintergrund.
  var CACHE_PREFIX = 'dsColorswGroup1:';
  function readCache(url) {
    try { var raw = sessionStorage.getItem(CACHE_PREFIX + url); return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
  }
  function writeCache(url, products) {
    try { sessionStorage.setItem(CACHE_PREFIX + url, JSON.stringify(products)); } catch (e) {}
  }

  // Die Abfrage startet schon im Snippet (inline, waehrend die Seite noch
  // aufgebaut wird) — hier nur uebernehmen, sonst selbst starten.
  function fetchGroup(url) {
    var early = window.dsColorswRequests && window.dsColorswRequests[url];
    var req = early || fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; });
    return req
      .then(function (d) { return d && d.active ? d.products : null; })
      .catch(function () { return null; });
  }

  /* ---------- Init eines Switchers ---------- */
  function init(root) {
    if (root.dataset.dsColorswReady === '1') return;
    root.dataset.dsColorswReady = '1';

    var row = root.querySelector('[data-colorsw-row]');
    var nameEl = root.querySelector('[data-colorsw-name]');
    var labelEl = root.querySelector('.ds-colorsw__label');
    var toggle = root.querySelector('[data-colorsw-toggle]');
    var toggleText = root.querySelector('[data-colorsw-toggle-text]');
    var groupUrl = root.dataset.groupUrl;
    if (!row || !groupUrl) { root.remove(); return; }

    var current = root.dataset.current;
    var count = 0;

    // Legende unter der Zeile — nur fuer Bundles mit unterschiedlichen Farben:
    // "Enthält 4 Paar: ●●●● je 1× in deiner Grösse".
    var legend = document.createElement('div');
    legend.className = 'ds-colorsw__legend';
    legend.hidden = true;
    row.insertAdjacentElement('afterend', legend);

    function renderLegend(active) {
      var cols = packColors(active);
      legend.innerHTML = '';
      legend.hidden = !cols;
      if (!cols) return;
      var strong = document.createElement('strong');
      strong.textContent = fill(root.dataset.legendContains, active.pack);
      legend.appendChild(strong);
      var dots = document.createElement('span');
      dots.className = 'ds-colorsw__legend-dots';
      cols.forEach(function (hex) {
        var dot = document.createElement('span');
        dot.className = 'ds-colorsw__legend-dot';
        dot.style.backgroundColor = hex;
        dots.appendChild(dot);
      });
      legend.appendChild(dots);
      var note = document.createElement('span');
      note.textContent = root.dataset.legendEach;
      legend.appendChild(note);
    }

    // Reihenfolge kommt schon "Meistverkauft zuerst" (sort_by=best-selling)
    // aus der Gruppenabfrage und bleibt so.
    function render(list) {
      list.forEach(function (it) { it.name = colorName(it.t); it.pack = packCount(it); });
      count = list.length;

      // Familie mit Multipacks? -> Ueberschrift "Variante:" statt "Farbe:".
      var hasBundles = list.some(function (it) { return it.pack > 1; });
      if (labelEl) labelEl.textContent = hasBundles ? root.dataset.labelVariant : root.dataset.labelColor;

      var active = list.filter(function (it) { return it.cur; })[0] || list[0];
      if (nameEl) nameEl.textContent = active.name;

      // Kacheln bauen (Links -> native Navigation zur Variante).
      var frag = document.createDocumentFragment();
      list.forEach(function (it) {
        var a = document.createElement('a');
        a.className = 'ds-colorsw__swatch';
        a.href = it.u;
        a.setAttribute('role', 'listitem');
        a.title = it.pack > 1 ? (it.name + ' · ' + fill(root.dataset.pairs, it.pack)) : it.name;
        a.setAttribute('aria-label', a.title);
        a.dataset.handle = it.h;
        a.dataset.available = String(it.av !== false);
        // Kachel: eigenes Kachelbild > Pack-Farben-Kreis > Hauptbild (gezoomt).
        var cols = packColors(it);
        if (it.k && it.img) {
          a.style.backgroundImage = 'url("' + it.img + '")';
        } else if (cols) {
          a.style.backgroundImage = conicGradient(cols);
        } else if (it.img) {
          a.style.backgroundImage = 'url("' + it.img + '")';
          a.classList.add('ds-colorsw__swatch--zoom');
        }
        if (it.cur) { a.setAttribute('data-active', 'true'); a.setAttribute('aria-current', 'true'); }
        // Paar-Anzahl-Badge (nur Packs).
        if (it.pack > 1) {
          var badge = document.createElement('span');
          badge.className = 'ds-colorsw__badge';
          badge.textContent = it.pack;
          badge.setAttribute('aria-hidden', 'true');
          a.appendChild(badge);
        }
        frag.appendChild(a);
      });
      row.innerHTML = '';
      row.appendChild(frag);
      renderLegend(active);
      if (toggleText) toggleText.textContent = fill(root.dataset.showAll, count);
      requestAnimationFrame(function () {
        updateToggle();
        scrollActiveIntoView();
      });
    }

    // Aktive Kachel (eingeklappt) in Sicht scrollen.
    function scrollActiveIntoView() {
      var act = row.querySelector('[data-active="true"]');
      if (act && root.getAttribute('data-open') !== 'true') {
        row.scrollTo({ left: act.offsetLeft - row.clientWidth / 2 + act.clientWidth / 2, behavior: 'smooth' });
      }
    }

    // Toggle nur zeigen, wenn die Zeile überläuft (mehr Kacheln als sichtbar).
    function updateToggle() {
      if (!toggle) return;
      toggle.hidden = !(row.scrollWidth > row.clientWidth + 4);
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = root.getAttribute('data-open') === 'true';
        root.setAttribute('data-open', String(!open));
        toggle.setAttribute('aria-expanded', String(!open));
        if (toggleText) toggleText.textContent = !open ? root.dataset.showLess : fill(root.dataset.showAll, count);
        if (open) scrollActiveIntoView();
      });
    }
    window.addEventListener('resize', updateToggle);

    // 1) Sofort: Gruppe aus dem Browser-Cache, sonst nur die aktuelle Farbe
    //    (kommt mit der Seite im Daten-Island) — nie eine leere Zeile.
    var shown = '';
    var cached = validGroup(readCache(groupUrl), current);
    if (cached) {
      render(cached);
      shown = JSON.stringify(cached);
    } else {
      var selfItem = null;
      var dataEl = root.querySelector('[data-colorsw-self]');
      try { selfItem = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) {}
      if (selfItem) { selfItem.cur = true; render([selfItem]); }
    }

    // 2) Frische Gruppe (meistverkaufte zuerst) uebernehmen und merken; neu
    //    zeichnen nur, wenn sich etwas geaendert hat (Reihenfolge, Bild,
    //    Verfuegbarkeit ...).
    fetchGroup(groupUrl).then(function (products) {
      var group = validGroup(products, current);
      if (!group) {
        if (!cached) root.remove();
        return;
      }
      writeCache(groupUrl, products);
      if (JSON.stringify(group) !== shown) render(group);
    });
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('.ds-colorsw')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
